<style lang="sass">
    @import ~nespresso-bi/utilities
    @import ~nespresso-bi/brand/variables
    @import variables
    @import quantitySelector
</style>

<template lang="html">
    <div class="g_quantity_scene">
        <div class="g_quantity_popin" ref="quantityPopin" tabindex="-1">
            <div class="g_quantity-popin-content">
                <template v-if="opened">
                    <button class="g_close" @click="$emit('update:opened', false)">
                        <i aria-hidden="true" class="fn_close"></i>
                        <span class="g_visually_hidden" v-text="voices.close"></span>
                    </button>
                    <p class="g_visually_hidden" v-text="voices.howTo"></p>
                    <form role="form" @submit.prevent>
                        <div class="g_productRow">
                            <div class="g_product">
                                <div class="g_productImage" v-if="isTouch" :style="`background-image: url(${product.images.icon})`"></div>
                                <span v-html="product.name"></span>
                                <p class="g_productPrice" v-text="product.displayedPrice" v-show="showPriceInQS" :data-disabled="!product.inStock"></p>
                            </div>
                        </div>
                        <div class="g_quantitySelectorRow">
                            <ul class="g_quantitySelector">
                                <li v-for="quantity in quantities">
                                    <button @click="set(quantity)" :class="{g_activeQuantity: quantity === activeQuantity }" :disabled="quantity > maxQuantity">
                                        <span class="g_visually_hidden" v-text="btnLabelAdd"></span>
                                        <span v-text="quantity"></span>
                                        <span v-html="product.name" class="g_visually_hidden"></span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="g_quantityOtherRow">
                            <div class="g_quantityOther">
                                <label v-if="maxQuantity < Infinity" v-text="warningProductLimit"></label>
                                <template v-else>
                                    <label :for="'g_quantity_selector_other' + _uid" v-text="voices.chooseQuantity" class="g_visually_hidden"></label><!--
                                    --><input v-if="isTouch" v-model="customQuantity" type="number" :step="step" :min="0" pattern="[0-9]*" inputmode="numeric" :id="'g_quantity_selector_other' + _uid" :placeholder="voices.otherQuantity" :aria-describedby="'g_quantity_selector_hint' + _uid" maxlength="4"><!--
                                    --><input v-else v-model="customQuantity" type="text" :step="step" :min="0" pattern="[0-9]*" inputmode="numeric" :id="'g_quantity_selector_other' + _uid" :placeholder="voices.otherQuantity" :aria-describedby="'g_quantity_selector_hint' + _uid" maxlength="4"><!--
                                    --><span :id="'g_quantity_selector_hint' + _uid" class="g_visually_hidden" v-text="voices.otherQuantity"></span><!--
                                    --><button class="g_valid" @click="set(customQuantity)">
                                           <span>OK</span>
                                       </button>
                                </template>
                            </div>
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { on, off, toggleClass, contains } from 'gaspard'
import dataLayer from 'nespresso-library/src/core/dataLayer'
import isTouch from 'nespresso-library/src/utils/isTouch'

const html = document.documentElement

export default {
    props: {
        opened: Boolean,
        product: Object,
        quantities: Array,
        voices: Object,
        activeQuantity: Number,
        step: Number,
        btnLabelAdd: String,
        showPriceInQS: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            customQuantity: null,
            // voiceClickToRemove: null,
            warningProductLimit: null,
            maxQuantity: Infinity,
            isTouch
        }
    },
    created () {
        this.setRule()
    },
    watch: {
        product (value, oldValue) {
            if (value.sku !== oldValue.sku) {
                this.setRule()
            }
        },
        opened (value) {
            this.$emit('update:opened', value)
            window.setTimeout(() => (value ? on : off)(document, 'click', this.clickOutside))
            if (value) {
                toggleClass(html, 'QSOpened', true)
                if (isTouch) {
                    this._lastPageYScroll = window.pageYOffset
                }
            } else {
                window.setTimeout(() => toggleClass(html, 'QSOpened', false), 1500)
                if (isTouch && (this._lastPageYScroll !== window.pageYOffset)) {
                    window.scrollTo(0, this._lastPageYScroll)
                }
            }
        },
        activeQuantity (value) {
            this.customQuantity = ~this.quantities.indexOf(value) ? null : value
        }
    },
    methods: {
        set (quantity) {
            quantity = Number(quantity)
            if (isNaN(quantity)) {
                quantity = this.quantities[this.quantities.length - 1]
            } else if (quantity > this.maxQuantity) {
                quantity = this.maxQuantity
            }
            if (Number(this.customQuantity) === 0) {
                this.customQuantity = null
            }
            this.$emit('setQuantity', quantity, true)
        },
        clickOutside (e) {
            if (this.opened && !contains(this.$refs.quantityPopin, e.target)) {
                this.$emit('update:opened', false)
            }
        },
        setRule () {
            window.napi
                .market()
                .getPackagingRules()
                .then(packagingRules => {
                    for (const packagingRule of packagingRules) {
                        for (const product of packagingRule.products) {
                            if (product === this.product.id) {
                                if (packagingRule.type === 'MAX') {
                                    this.maxQuantity = packagingRule.value / this.product.unitQuantity
                                    let warningProductLimit = window.config
                                    if (dataLayer.isMobile) {
                                        warningProductLimit = warningProductLimit.warningProductLimit
                                    } else if (dataLayer.isResponsive || dataLayer.isMosaic) {
                                        warningProductLimit = warningProductLimit.labels.quantitySelector.warningProductLimit
                                    } else {
                                        warningProductLimit = ''
                                    }
                                    this.warningProductLimit = warningProductLimit.replace('{0}', packagingRule.value)
                                }
                                break
                            }
                        }
                    }
                })
        }
    }
}
</script>
